module.exports = __webpack_public_path__ + "static/media/icon-credit-card.47905ede.svg";